import { NgModule } from '@angular/core'
import { MediaService } from '@spartacus/storefront'
import { EbMediaService } from '../../features/media/eb-media.service'

@NgModule({
  providers: [
    EbMediaService,
    {
      provide: MediaService,
      useClass: EbMediaService
    }
  ]
})
export class EbMediaModule {}
